import { create } from "zustand";

interface FreeCourseClaimModalState {
	isOpen: boolean;
	open: () => void;
	close: () => void;
}

/** Open state for the "Use your free course?" confirmation on a course page. */
const useFreeCourseClaimModal = create<FreeCourseClaimModalState>((set) => ({
	isOpen: false,
	open: () => set({ isOpen: true }),
	close: () => set({ isOpen: false }),
}));

export default useFreeCourseClaimModal;
